var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaEnkeltRedStatistik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 23.5,
    viewBox: "0 0 30.5 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(-216.956 -128.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    d: "M0-.75H5A.75.75,0,0,1,5.75,0V13a.75.75,0,0,1-.75.75H0A.75.75,0,0,1-.75,13V0A.75.75,0,0,1,0-.75ZM4.25.75H.75v11.5h3.5Z",
    transform: "translate(217.706 138.392)",
    fill: "#ff1e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    d: "M0-.75H5A.75.75,0,0,1,5.75,0V16a.75.75,0,0,1-.75.75H0A.75.75,0,0,1-.75,16V0A.75.75,0,0,1,0-.75ZM4.25.75H.75v14.5h3.5Z",
    transform: "translate(225.706 135.392)",
    fill: "#ff1e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    d: "M0-.75H5A.75.75,0,0,1,5.75,0V19a.75.75,0,0,1-.75.75H0A.75.75,0,0,1-.75,19V0A.75.75,0,0,1,0-.75ZM4.25.75H.75v17.5h3.5Z",
    transform: "translate(233.706 132.392)",
    fill: "#ff1e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    d: "M0-.75H5A.75.75,0,0,1,5.75,0V22a.75.75,0,0,1-.75.75H0A.75.75,0,0,1-.75,22V0A.75.75,0,0,1,0-.75ZM4.25.75H.75v20.5h3.5Z",
    transform: "translate(241.706 129.392)",
    fill: "#ff1e56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaEnkeltRedStatistik);
export default __webpack_public_path__ + "static/media/sa-enkelt-red-statistik.6273737896e173c5084d9a1870c18774.svg";
export { ForwardRef as ReactComponent };